import { getAxiosInstance, getQueryStringFromObject } from "./common.service";

async function getMovies(query = {}) {
    try {
        const axios = await getAxiosInstance();
        let queryString = await getQueryStringFromObject(query);
        if (queryString) {
            queryString = '?' + queryString;
        } else {
            queryString = '';
        }
        let response = await axios.get('/movies' + queryString);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

async function postMovieAnswer(data) {
    try {
        const axios = await getAxiosInstance();
        let response = await axios.post('/movie_answers', data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export {
    getMovies,
    postMovieAnswer
}